// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"188":"66ca99b5","443":"775a3a7c","856":"73693324"}[chunkId] + ".js";
};